export default __webpack_public_path__ + "static/media/accent-search-button.a61330c1.svg";